module.exports = __webpack_public_path__ + "img/404.9cfca102.png";